import { Component } from "solid-js";

interface BeautyIconProps {
  class?: string;
}

export const BeautyIcon: Component<BeautyIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M28.0051 15.9999C28.0051 22.6301 22.6303 28.0049 16.0001 28.0049C9.36994 28.0049 3.99512 22.6301 3.99512 15.9999C3.99512 9.36976 9.36994 3.99493 16.0001 3.99493"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.4569 3.18388C24.6328 2.86187 24.9704 2.66156 25.3373 2.66156C25.7042 2.66156 26.0418 2.86187 26.2177 3.18388L26.9953 4.60447C27.0876 4.77346 27.2265 4.91236 27.3955 5.00464L28.8161 5.78096C29.1388 5.9566 29.3396 6.2946 29.3396 6.662C29.3396 7.02939 29.1388 7.36739 28.8161 7.54303L27.3955 8.32069C27.2261 8.41241 27.087 8.55145 26.9953 8.72086L26.2177 10.1401C26.0418 10.4621 25.7042 10.6624 25.3373 10.6624C24.9704 10.6624 24.6328 10.4621 24.4569 10.1401L23.6793 8.71952C23.5875 8.55012 23.4485 8.41108 23.2791 8.31935L21.8585 7.54303C21.5358 7.36739 21.335 7.02939 21.335 6.662C21.335 6.2946 21.5358 5.9566 21.8585 5.78096L23.2791 5.00464C23.4481 4.91236 23.587 4.77346 23.6793 4.60447L24.4569 3.18388Z"
        class="stroke-inherit"
        stroke-width="2"
      />
      <path
        d="M11.9985 12.4384V13.7723"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.0017 12.4384V13.7723"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.3246 19.5455C17.9361 21.9321 14.0655 21.9321 11.677 19.5455"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
